import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import DefterKasaPage from '@/pages/defter-kasa/page';
import DefterKasaPrivacyPage from '@/pages/defter-kasa/PrivacyPage';
import KozmikGunlukPage from '@/pages/kozmik-gunluk/page';
import AppsPage from '@/pages/apps/page';
import GamesPage from '@/pages/games/page';
import AnilarMuzesiPage from '@/pages/anilar-muzesi/page';
import WebsiteOfferPage from '@/pages/web-site-mi-istiyorsunuz/page';
import MaintenanceControlPage from '@/pages/bakim-kontrol/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/',                              element: <HomePage /> },
  { path: '/apps',                          element: <AppsPage /> },
  { path: '/games',                         element: <GamesPage /> },
  { path: '/anilar-muzesi',                 element: <AnilarMuzesiPage /> },
  { path: '/web-site-mi-istiyorsunuz',      element: <WebsiteOfferPage /> },
  { path: '/bakim-kontrol',                 element: <MaintenanceControlPage /> },
  { path: '/defter-kasa',                   element: <DefterKasaPage /> },
  { path: '/defter-kasa/gizlilik-politikasi', element: <DefterKasaPrivacyPage /> },
  { path: '/kozmik-gunluk',                 element: <KozmikGunlukPage /> },
  { path: '*',                              element: <NotFound /> },
];

export default routes;

